import { Images } from "assets";
import { Svg } from "assets/svg";
import React, { useState, useEffect } from "react";
import { Image, StyleSheet, View, TouchableOpacity, ScrollView, FlatList, ActivityIndicator } from "react-native";
import { fp, hp, wp } from "utils/normalizeV2";
import VText from "components/VText";
import BottomSheetModal from "components/BottomSheetModal";
import Buttons from "components/Buttons";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { getFilteredProducts } from "appRedux/reducers/homeSlice";
import ListView from "components/ListView";



const SearchProducts = ({ newSelectedProducts, setNewSelectedProducts, searchKey }) => {


    const   [products, setProducts] = useState([]);
    const   [page, setPage] = useState(1);
    const   [limit, setLimit] = useState(9);
    const   [isLoading, setIsLoading] = useState(false);
    const   [isLoadingMore, setIsLoadingMore] = useState(false);
    const dispatch = useDispatch();


    useEffect(() => {
        if(!isLoading){
            fetchProducts();
        }
    }, [page]);


    useEffect(() => {
        setProducts([]);
        setPage(1);
        fetchProducts();

    }, [searchKey]);

    const fetchProducts = async () => {
        setIsLoading(true);
        let data = {limit: limit,page: page}
        if(searchKey){ data.key = searchKey;}
        dispatch(getFilteredProducts({data})).then((res) => {
            if(res.payload?.status === 200){
                // Append new products to existing ones instead of replacing
                setProducts(prevProducts => {
                    const newProducts = res.payload.data.data.productDetails;
                    const updatedProducts = newProducts.filter(newProduct => !prevProducts.some(prevProduct => prevProduct.productId === newProduct.productId));
                    return [...prevProducts, ...updatedProducts];
                });
            }
            setIsLoading(false);
            setIsLoadingMore(false);
        });
    }

    const handleProductSelection = (item) => {
        setNewSelectedProducts((prev) =>
            prev.some((product) => product.productId === item.productId)
                ? prev.filter((product) => product.productId !== item.productId)
                : [...prev, item]
        );
    }


    const handleLoadMore = () => {
            setIsLoadingMore(true);
            setPage(prevPage => prevPage + 1);
    }

    const renderGridItem = (item) => (
        <TouchableOpacity onPress={() => handleProductSelection(item)} key={item.id} style={styles.gridItem}>
            <TouchableOpacity onPress={() => handleProductSelection(item)} style={styles.imageContainer}>
                <Image source={{ uri: item?.imageUrls[0] }} style={styles.productImage} resizeMode="contain" />
            </TouchableOpacity>
            <View style={{paddingVertical: wp(5)}}>
                    <VText style={styles.brandName}>{item?.brandName}</VText>
                    <VText style={styles.productName} numberOfLines={2}>
                        {item?.productName}
                    </VText>
                    <VText style={styles.productPrice}>${item?.productPrice}</VText>
                </View>
            <TouchableOpacity onPress={() => handleProductSelection(item)} style={styles.checkButton}>
                <Image
                    source={
                        newSelectedProducts?.some((product) => product.productId === item.productId) ? Images.blackSelect : Images.greySelect
                    }
                    style={styles.checkIcon}
                />

            </TouchableOpacity>
        </TouchableOpacity>
    );

    return (
        <View style={styles.container}>

            {products.length === 0 ? (
                <View style={styles.emptyContainer}>
                    <ActivityIndicator size="large" color={'#000'} />
                    {/* <VText>No products found</VText> */}
                </View>
            ) : (
                <ListView
                data={products}
                renderItem={({ item }) => renderGridItem(item)}
                keyExtractor={item => item.id}
                onEndReached={handleLoadMore}
                onEndReachedThreshold={0.5}
                numColumns={3}
                contentContainerStyle={styles.gridContainer}
                showsVerticalScrollIndicator={false}
                nestedScrollEnabled={true}
            />
            )}

            

           
            {isLoadingMore && (
                <View style={styles.loadingContainer}>
                    <ActivityIndicator size="small" color={'#000'} />
                </View>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "white",
        minHeight: hp(600),
    },
    title: {
        fontSize: fp(18),
        fontWeight: "400",
        color: '#21242799',
        textAlign: "center",
        marginBottom: hp(10),
    },
    gridContainer: {
        marginLeft: wp(5),
        width: wp(750),
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        gap: wp(4),
    },
    gridItem: {
        width: wp(245),
        padding: wp(5),
        // height: hp(400),
        // backgroundColor: "red",
    },
    imageContainer: {
        width: "100%",
        aspectRatio: 1,
        // height: hp(200),
        overflow: "hidden",
        position: "relative",
        padding: wp(5),
    },
    productImage: {
        width: "100%",
        height: "80%",
    },
    checkButton: {
        position: "absolute",
        bottom: wp(90),
        right: wp(30),

    },
    checkIcon: {
        width: wp(20),
        height: wp(20),
    },
    selectedProductsContainer: {
        marginTop: hp(20),
    },
    selectedProductsContent: {
        paddingHorizontal: wp(5),
        flexDirection: "row",
    },
    selectedProduct: {
        width: wp(150),
        height: wp(150),
    },
    modalContainer: {
        backgroundColor: "transparent",
        width: '100%',
        height: '100%',
        alignItems: "center",
        justifyContent: "center",
    },
    modalContent: {
        width: wp(350),
        height: hp(142),
        backgroundColor: "white",
        borderRadius: wp(3),
        alignItems: "center",
        justifyContent: "center",
        paddingHorizontal: wp(20),
    },
    modalTitle: {
         fontSize: fp(18),
         fontWeight: "400",
         color: "black",
         textAlign:"center",
         marginTop:hp(20) 
    },
    modalButtonsContainer: {
         flexDirection: "row",
         alignItems: "stretch", 
         justifyContent: "center",
         marginTop:hp(30) 
        },
    modalButton: {
        width: wp(135),
        height: hp(50),
        backgroundColor: "white",
        alignItems: "center",
        justifyContent: "center",
        borderTopWidth: 1,
        borderColor: "#3C3C435C",
    },
    modalButtonText: {
        fontSize: fp(16),
        fontWeight: "600",
        color: "#212427",
    },
    loadingContainer: {
        padding: hp(10),
        alignItems: "center",
    },
    brandName:{
        marginTop: hp(5),
        fontSize: fp(12),
        fontWeight: "500",
        // color: "#21242799",
    },
    productName: {
        marginTop: hp(5),
        fontSize: fp(12),
        fontWeight: "350",
    },
    productPrice: {
        marginTop: hp(5),
        fontSize: fp(12),
        fontWeight: "350",

    },
    emptyContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    emptyImage: {
        width: wp(50),
        height: wp(50),
    }   
});

export default React.memo(SearchProducts);
